// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--2d913";
export var footer__appStoreIcon = "Footer-module--footer__appStoreIcon--6111b";
export var footer__body = "Footer-module--footer__body--c3eda";
export var footer__bottom = "Footer-module--footer__bottom--79b04";
export var footer__copyright = "Footer-module--footer__copyright--2abe6";
export var footer__corporateLogo = "Footer-module--footer__corporateLogo--22eda";
export var footer__corporateMessage = "Footer-module--footer__corporateMessage--c0fc6";
export var footer__instagramIconLink = "Footer-module--footer__instagramIconLink--3544a";
export var footer__lang = "Footer-module--footer__lang--f0e40";
export var footer__links = "Footer-module--footer__links--a172c";
export var footer__linksTitle = "Footer-module--footer__linksTitle--ced59";
export var footer__logo = "Footer-module--footer__logo--1d930";
export var footer__logoContainer = "Footer-module--footer__logoContainer--b55c6";
export var footer__section = "Footer-module--footer__section--6164e";
export var footer__section__container = "Footer-module--footer__section__container--d6d29";
export var footer__section__content = "Footer-module--footer__section__content--bec5a";
export var footer__section__title = "Footer-module--footer__section__title--e6b46";
export var footer__sections = "Footer-module--footer__sections--30fde";
export var footer__socialLinksContainer = "Footer-module--footer__socialLinksContainer--a3777";
export var footer__socialLinksContainer__links = "Footer-module--footer__socialLinksContainer__links--e114a";
export var langToggle__alternative = "Footer-module--langToggle__alternative--ad8ec";
export var langToggle__current = "Footer-module--langToggle__current--d40dd";
export var logoImage = "Footer-module--logoImage--dc86e";
export var noLogo = "Footer-module--noLogo--3e875";
export var tab = "Footer-module--tab--7b2d8";
export var tab__content = "Footer-module--tab__content--77242";
export var tab__label = "Footer-module--tab__label--3340e";
export var tab__label__chevron = "Footer-module--tab__label__chevron--5a911";